import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { MinistryAppointmentApiService } from '@core/api/services/ministry-appointment-api.service';
import {
  MinistryAppointmentDto,
  CreateMinistryAppointmentDto,
  UpdateMinistryAppointmentDto,
  UpdateMinistryAppointmentSortOrderDto,
} from '@core/api/generated/api-client';

export { MinistryAppointmentDto, CreateMinistryAppointmentDto, UpdateMinistryAppointmentDto };

@Injectable({ providedIn: 'root' })
export class MinistryAppointmentManagementService {
  constructor(private readonly api: MinistryAppointmentApiService) {}

  getAll(): Observable<MinistryAppointmentDto[]> {
    return this.api.getAll();
  }

  getById(id: number): Observable<MinistryAppointmentDto> {
    return this.api.getById(id);
  }

  create(dto: CreateMinistryAppointmentDto): Observable<MinistryAppointmentDto> {
    return this.api.create(dto);
  }

  update(id: number, dto: UpdateMinistryAppointmentDto): Observable<void> {
    return this.api.update(id, dto);
  }

  delete(id: number): Observable<void> {
    return this.api.delete(id);
  }

  updateSortOrder(id: number, sortOrder: number): Observable<void> {
    return this.api.updateSortOrder(id, UpdateMinistryAppointmentSortOrderDto.fromJS({ sortOrder }));
  }
}
